import Plotly from "plotly.js-dist-min";

const DEFAULT_DELAYS_MS = [0, 150, 350];
const DEFAULT_MOUNT_ATTEMPTS = 12;
const DEFAULT_MOUNT_DELAY_MS = 50;

function resizePlotlyElements() {
  if (typeof document === "undefined") return;

  const seen = new Set();
  document.querySelectorAll(".js-plotly-plot").forEach((el) => {
    if (!el || seen.has(el)) return;
    seen.add(el);

    if (!el._fullLayout && !el.querySelector?.(".plotly")) return;

    try {
      Plotly.Plots.resize(el);
    } catch {
      void 0;
    }
  });
}

/** Resize every Plotly chart after layout shifts (e.g. left/right sidebar toggle). */
export function resizeAllPlotlyCharts(options = {}) {
  const delays = options.delays ?? DEFAULT_DELAYS_MS;

  delays.forEach((delay) => {
    if (delay <= 0) {
      requestAnimationFrame(resizePlotlyElements);
    } else {
      setTimeout(resizePlotlyElements, delay);
    }
  });
}

export function resolvePlotlyElement(ref) {
  if (!ref) return null;
  if (Array.isArray(ref)) return resolvePlotlyElement(ref[0]);
  if (typeof Node !== "undefined" && ref instanceof Node) return ref;
  if (ref.$el) return resolvePlotlyElement(ref.$el);
  if (typeof ref === "object" && typeof ref.length === "number" && ref.length > 0) {
    return resolvePlotlyElement(ref[0]);
  }
  return null;
}

export function schedulePlotlyMount(getRef, plot, options = {}) {
  const attempts = options.attempts ?? DEFAULT_MOUNT_ATTEMPTS;
  const delay = options.delay ?? DEFAULT_MOUNT_DELAY_MS;

  const tryMount = (left) => {
    const el = resolvePlotlyElement(typeof getRef === "function" ? getRef() : getRef);
    if (el) {
      const height = el.clientHeight || 320;
      Promise.resolve(plot(el, height))
        .then(() => {
          try {
            Plotly.Plots.resize(el);
          } catch {
            void 0;
          }
        })
        .catch(() => {});
      return;
    }
    if (left <= 0) return;
    setTimeout(() => tryMount(left - 1), delay);
  };

  if (typeof requestAnimationFrame === "function") {
    requestAnimationFrame(() => tryMount(attempts));
  } else {
    tryMount(attempts);
  }
}
